import EatOutApp from "./eat-out-app/eat-out-app.ts";

globalThis.customElements.define("eat-out-app", EatOutApp);
